import { Divider, Heading, Paragraph } from '@zillow/constellation';
import React from 'react';

export default function Address({ data }) {
  const { street, city, state, zip } = data.rentalListing.address;
  const subheading = [[city, state].filter(Boolean).join(', '), zip].filter(Boolean).join(' ');
  return (
    <>
      <Heading level={3}>{street}</Heading>
      <Paragraph fontType="body" marginBottom="sm">
        {subheading}
      </Paragraph>
      <Divider />
    </>
  );
}
